import React, { useEffect, useState } from "react";
import { ImGithub } from "react-icons/im";
import { FaCodeBranch, FaUsers, FaFolderOpen, FaStar } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./cssgithub.css";

const GitHubGraph = ({ username = "Aubin9" }) => {
  const { i18n } = useTranslation();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const isFr = i18n.language === "fr";

  useEffect(() => {
    const fetchGitHubData = async () => {
      try {
        const res = await axios.get(`https://api.github.com/users/${username}`);
        setUserData(res.data);
      } catch (err) {
        console.error("Error fetching GitHub profile:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchGitHubData();
  }, [username]);

  return (
    <div className="container github-section">
      <div className="github-card">
        <div className="github-header">
          <ImGithub className="github-icon" />
          <h3>
            {isFr ? "Activité GitHub & Open Source" : "GitHub Activity & Open Source"}
          </h3>
        </div>

        <p style={{ color: "var(--colorLight)", maxWidth: "600px", margin: "0 auto 1.5rem" }}>
          {isFr
            ? `Découvrez les contributions en direct, les dépôts et les projets open source de @${username}.`
            : `Explore live GitHub contributions, repositories, and open source projects by @${username}.`}
        </p>

        {!loading && userData && (
          <div className="github-stats-grid">
            <div className="github-stat-box">
              <div className="github-stat-num">{userData.public_repos || 0}</div>
              <div className="github-stat-label">
                <FaFolderOpen style={{ marginRight: "4px" }} />
                {isFr ? "Dépôts Publics" : "Public Repos"}
              </div>
            </div>

            <div className="github-stat-box">
              <div className="github-stat-num">{userData.followers || 0}</div>
              <div className="github-stat-label">
                <FaUsers style={{ marginRight: "4px" }} />
                {isFr ? "Abonnés" : "Followers"}
              </div>
            </div>

            <div className="github-stat-box">
              <div className="github-stat-num">{userData.following || 0}</div>
              <div className="github-stat-label">
                <FaCodeBranch style={{ marginRight: "4px" }} />
                {isFr ? "Abonnements" : "Following"}
              </div>
            </div>

            <div className="github-stat-box">
              <div className="github-stat-num">
                {userData.created_at ? new Date(userData.created_at).getFullYear() : "2021"}
              </div>
              <div className="github-stat-label">
                <FaStar style={{ marginRight: "4px" }} />
                {isFr ? "Membre Depuis" : "Member Since"}
              </div>
            </div>
          </div>
        )}

        <div className="github-calendar-wrapper">
          <a href={`https://github.com/${username}`} target="_blank" rel="noreferrer">
            <img
              className="github-calendar-img"
              src={`https://ghchart.rshah.org/00ff99/${username}`}
              alt={`GitHub Contributions chart for ${username}`}
            />
          </a>
        </div>

        <div style={{ marginTop: "1.5rem" }}>
          <a
            href={`https://github.com/${username}`}
            target="_blank"
            rel="noreferrer"
            className="btn btnPrimary"
          >
            {isFr ? "Voir le profil GitHub" : "Visit GitHub Profile"}
          </a>
        </div>
      </div>
    </div>
  );
};

export default GitHubGraph;
